//! Be sure to review and update the 'PX4.js' file
//! whenever you make changes to this file.

const toMavLink = (commands) => {
  const messages = [];
  commands.forEach((command) => {
    // Wait For Distance
    if (command.type === 'condDistance') {
      messages.push([
        messages.length,
        2, // MAV_FRAME_MISSION
        114, // MAV_CMD_CONDITION_DISTANCE
        0, // current
        1, // autocontinue
        command.data.distance,
        0, // param2
        0, // param3
        0, // param4
        0, // x
        0, // y
        0, // z
      ]);
    }
    // Wait For Yaw
    if (command.type === 'condYaw') {
      messages.push([
        messages.length,
        2, // MAV_FRAME_MISSION
        115, // MAV_CMD_CONDITION_YAW
        0, // current
        1, // autocontinue
        command.data.heading,
        command.data.rate,
        command.data.direction,
        command.data.offset,
        0, // x
        0, // y
        0, // z
      ]);
    }
    // Autotune Enable
    if (command.type === 'doAutotuneEnable') {
      messages.push([
        messages.length,
        0, // MAV_FRAME_GLOBAL
        212, // MAV_CMD_DO_AUTOTUNE_ENABLE
        0, // current
        1, // autocontinue
        command.data.enable,
        0, // param2
        0, // param3
        0, // param4
        0, // x
        0, // y
        0, // z
      ]);
    }
    // Change Speed
    if (command.type === 'doChangeSpeed') {
      messages.push([
        messages.length,
        2, // MAV_FRAME_MISSION
        178, // MAV_CMD_DO_CHANGE_SPEED
        0, // current
        1, // autocontinue
        command.data.type ?? 1, // 1: SPEED_TYPE_GROUNDSPEED
        command.data.speed,
        command.data.throttle ?? -1, // -1: no change
        0, // param4
        0, // x
        0, // y
        0, // z
      ]);
    }
    // Gripper
    else if (command.type === 'doGripper') {
      messages.push([
        messages.length,
        2, // MAV_FRAME_MISSION
        211, // MAV_CMD_DO_GRIPPER
        0, // current
        1, // autocontinue
        command.data.gripper,
        command.data.action,
        0, // param3
        0, // param4
        0, // x
        0, // y
        0, // z
      ]);
    }
    // Guided Limits
    else if (command.type === 'doGuidedLimits') {
      messages.push([
        messages.length,
        0, // MAV_FRAME_GLOBAL
        222, // MAV_CMD_DO_GUIDED_LIMITS
        0, // current
        1, // autocontinue
        command.data.timeout,
        command.data.minAlt,
        command.data.maxAlt,
        command.data.horizMoveLimit,
        0, // x
        0, // y
        0, // z
      ]);
    }
    // Set Camera Trigger Distance
    else if (command.type === 'doSetCamTriggDist') {
      messages.push([
        messages.length,
        2, // MAV_FRAME_MISSION
        206, // MAV_CMD_DO_SET_CAM_TRIGG_DIST
        0, // current
        1, // autocontinue
        command.data.distance, // distance
        0, // camera shutter integration time: ignore
        1, // trigger camera once immediately
        0, // param4
        0, // x
        0, // y
        0, // z
      ]);
    }
    // Set Relay
    else if (command.type === 'doSetRelay') {
      messages.push([
        messages.length,
        2, // MAV_FRAME_MISSION
        181, // MAV_CMD_DO_SET_RELAY
        0, // current
        1, // autocontinue
        command.data.relay,
        command.data.setting,
        0, // param3
        0, // param4
        0, // x
        0, // y
        0, // z
      ]);
    }
    // Cycle Relay
    else if (command.type === 'doRepeatRelay') {
      messages.push([
        messages.length,
        2, // MAV_FRAME_MISSION
        182, // MAV_CMD_DO_REPEAT_RELAY
        0, // current
        1, // autocontinue
        command.data.relay,
        command.data.count,
        command.data.time,
        0, // param4,
        0, // x
        0, // y
        0, // z
      ]);
    }
    // Set Region Of Interest
    else if (command.type === 'doSetRoiLocation') {
      messages.push([
        messages.length,
        3, // MAV_FRAME_GLOBAL_RELATIVE_ALT
        201, // MAV_CMD_DO_SET_ROI
        0, // current
        1, // autocontinue
        3, // MAV_ROI_LOCATION
        0, // param2
        0, // param3
        0, // param4
        command.data.position.lat * 1e7,
        command.data.position.lng * 1e7,
        command.data.altitude,
      ]);
    }
    // Set Region Of Interest None
    else if (command.type === 'doSetRoiNone') {
      messages.push([
        messages.length,
        3, // MAV_FRAME_GLOBAL_RELATIVE_ALT
        201, // MAV_CMD_DO_SET_ROI
        0, // current
        1, // autocontinue
        0, // MAV_ROI_NONE
        0, // param2
        0, // param3
        0, // param4
        0, // x
        0, // y
        0, // z
      ]);
    }
    // Set Servo
    else if (command.type === 'doSetServo') {
      messages.push([
        messages.length,
        2, // MAV_FRAME_MISSION
        183, // MAV_CMD_DO_SET_SERVO
        0, // current
        1, // autocontinue
        command.data.servo,
        command.data.pwm,
        0, // param3
        0, // param4
        0, // x
        0, // y
        0, // z
      ]);
    }
    // Cycle Servo
    else if (command.type === 'doRepeatServo') {
      messages.push([
        messages.length,
        2, // MAV_FRAME_MISSION
        184, // MAV_CMD_DO_REPEAT_SERVO
        0, // current
        1, // autocontinue
        command.data.servo,
        command.data.pwm,
        command.data.count,
        command.data.time,
        0, // x
        0, // y
        0, // z
      ]);
    }
    // Jump To Item
    else if (command.type === 'doJump') {
      messages.push([
        messages.length,
        2, // MAV_FRAME_MISSION
        177, // MAV_CMD_DO_JUMP
        0, // current
        1, // autocontinue
        command.data.item,
        command.data.repeat,
        0, // param3
        0, // param4
        0, // x
        0, // y
        0, // z
      ]);
    }
    // Trigger Parachute
    else if (command.type === 'doParachute') {
      messages.push([
        messages.length,
        2, // MAV_FRAME_MISSION
        208, // MAV_CMD_DO_PARACHUTE
        0, // current
        1, // autocontinue
        command.data.action,
        0, // param2
        0, // param3
        0, // param4
        0, // x
        0, // y
        0, // z
      ]);
    }
    // Change Altitude
    else if (command.type === 'navContinueAndChangeAlt') {
      messages.push([
        messages.length,
        3, // MAV_FRAME_GLOBAL_RELATIVE_ALT
        30, // MAV_CMD_NAV_CONTINUE_AND_CHANGE_ALT
        0, // current
        1, // autocontinue
        command.data.mode,
        0, // param2
        0, // param3
        0, // param4
        0, // x
        0, // y
        command.data.altitude,
      ]);
    }
    // Delay Until
    else if (command.type === 'navDelay') {
      messages.push([
        messages.length,
        2, // MAV_FRAME_MISSION
        93, // MAV_CMD_NAV_DELAY
        0, // current
        1, // autocontinue
        command.data.hold,
        command.data.hour,
        command.data.minute,
        command.data.second,
        0, // x
        0, // y
        0, // z
      ]);
    }
    // Guided Enable
    else if (command.type === 'navGuidedEnable') {
      messages.push([
        messages.length,
        2, // MAV_FRAME_MISSION
        92, // MAV_CMD_NAV_GUIDED_ENABLE
        0, // current
        1, // autocontinue
        command.data.enable,
        0, // param2
        0, // param3
        0, // param4
        0, // x
        0, // y
        0, // z
      ]);
    }
    // Land
    else if (command.type === 'navLand') {
      // 낙하산 사용 시
      if (command.data.parachute) {
        messages.push([
          messages.length,
          3, // MAV_FRAME_GLOBAL_RELATIVE_ALT
          16, // MAV_CMD_NAV_WAYPOINT
          0, // current
          1, // autocontinue
          0, // param1
          0, // param2
          0, // param3
          NaN, // param4
          command.data.position.lat * 1e7,
          command.data.position.lng * 1e7,
          command.data.altitude,
        ]);
        messages.push([
          messages.length,
          2, // MAV_FRAME_MISSION
          208, // MAV_CMD_DO_PARACHUTE
          0, // current
          1, // autocontinue
          1, // parachute action: PARACHUTE_ENABLE(1)
          0, // param2
          0, // param3
          0, // param4
          0, // param5
          0, // param6
          0, // param7
        ]);
        messages.push([
          messages.length,
          2, // MAV_FRAME_MISSION
          208, // MAV_CMD_DO_PARACHUTE
          0, // current
          1, // autocontinue
          2, // parachute action: PARACHUTE_RELEASE(2)
          0, // param2
          0, // param3
          0, // param4
          0, // param5
          0, // param6
          0, // param7
        ]);
      }

      messages.push([
        messages.length,
        3, // MAV_FRAME_GLOBAL_RELATIVE_ALT
        21, // MAV_CMD_NAV_LAND
        0, // current
        1, // autocontinue
        0, // param1
        0, // param2
        0, // param3
        NaN, // param4
        command.data.position.lat * 1e7,
        command.data.position.lng * 1e7,
        0,
      ]);
    }
    // Loiter (Time)
    else if (command.type === 'navLoiterTime') {
      messages.push([
        messages.length,
        3, // MAV_FRAME_GLOBAL_RELATIVE_ALT
        19, // MAV_CMD_NAV_LOITER_TIME
        0, // current
        1, // autocontinue
        command.data.loiterTime,
        1, // param2
        50, // param3
        1, // param4
        command.data.position.lat * 1e7,
        command.data.position.lng * 1e7,
        command.data.altitude,
      ]);
    }
    // Loiter (Altitude)
    else if (command.type === 'navLoiterToAlt') {
      messages.push([
        messages.length,
        3, // MAV_FRAME_GLOBAL_RELATIVE_ALT
        31, // MAV_CMD_NAV_LOITER_TO_ALT
        0, // current
        1, // autocontinue
        1, // param1
        50, // param2
        0, // param3
        1, // param4
        command.data.position.lat * 1e7,
        command.data.position.lng * 1e7,
        command.data.altitude,
      ]);
    }
    // Loiter (Turns)
    else if (command.type === 'navLoiterTurns') {
      messages.push([
        messages.length,
        3, // MAV_FRAME_GLOBAL_RELATIVE_ALT
        18, // MAV_CMD_NAV_LOITER_TURNS
        0, // current
        1, // autocontinue
        command.data.turns,
        1, // param2
        50, // param3
        1, // param4
        command.data.position.lat * 1e7,
        command.data.position.lng * 1e7,
        command.data.altitude,
      ]);
    }
    // Return To Launch
    else if (command.type === 'navReturnToLaunch') {
      messages.push([
        messages.length,
        2, // MAV_FRAME_MISSION
        20, // MAV_CMD_NAV_RETURN_TO_LAUNCH
        0, // current
        1, // autocontinue
        0, // param1
        0, // param2
        0, // param3
        0, // param4
        0,
        0,
        0,
      ]);
    }
    // Takeoff
    else if (command.type === 'navTakeoff') {
      messages.push([
        messages.length,
        0, // MAV_FRAME_GLOBAL
        16, // MAV_CMD_NAV_WAYPOINT
        1, // current
        1, // autocontinue
        0, // param1
        0, // param2
        0, // param3
        0, // param4
        command.data.position.lat * 1e7,
        command.data.position.lng * 1e7,
        command.data.elevation,
      ]);
      messages.push([
        messages.length,
        3, // MAV_FRAME_GLOBAL_RELATIVE_ALT
        22, // MAV_CMD_NAV_TAKEOFF
        0, // current
        1, // autucontinue
        0, // param1
        0, // param2
        0, // param3
        NaN, // param4
        command.data.position.lat * 1e7,
        command.data.position.lng * 1e7,
        command.data.altitude,
      ]);
    }
    // Waypoint
    else if (command.type === 'navWaypoint') {
      messages.push([
        messages.length,
        3, // MAV_FRAME_GLOBAL_RELATIVE_ALT
        16, // MAV_CMD_NAV_WAYPOINT
        0, // current
        1, // autocontinue
        0, // param1
        0, // param2
        0, // param3
        NaN, // param4
        command.data.position.lat * 1e7,
        command.data.position.lng * 1e7,
        command.data.altitude,
      ]);

      // 속도 변경하는 경우
      if (command.data.speed) {
        messages.push([
          messages.length,
          2, // MAV_FRAME_MISSION
          178, // MAV_CMD_DO_CHANGE_SPEED
          0, // current
          1, // autocontinue
          1, // speed type: SPEED_TYPE_GROUNDSPEED
          command.data.speed, // speed
          -1, // throttle: no change
          0, // param4
          0, // x
          0, // y
          0, // z
        ]);
      }
    }
  });
  return messages;
};

const fromMavLink = (messages) => {
  const commands = [];
  messages.forEach((message, index) => {
    // 16: MAV_CMD_NAV_WAYPOINT
    if (message.command === 16) {
      commands.push({
        id: index,
        type: 'navWaypoint',
        data: {
          name: '',
          position: {
            lat: message.x / 1e7,
            lng: message.y / 1e7,
          },
          altitude: message.z,
        },
      });
    }
    // 18: MAV_CMD_NAV_LOITER_TURNS
    else if (message.command === 18) {
      commands.push({
        id: index,
        type: 'navLoiterTurns',
        data: {
          turns: message.param1,
          position: {
            lat: message.x / 1e7,
            lng: message.y / 1e7,
          },
          altitude: message.z,
        },
      });
    }
    // 19: MAV_CMD_NAV_LOITER_TIME
    else if (message.command === 19) {
      commands.push({
        id: index,
        type: 'navLoiterTime',
        data: {
          loiterTime: message.param1,
          position: {
            lat: message.x / 1e7,
            lng: message.y / 1e7,
          },
          altitude: message.z,
        },
      });
    }
    // 20: MAV_CMD_NAV_RETURN_TO_LAUNCH
    else if (message.command === 20) {
      commands.push({
        id: index,
        type: 'navReturnToLaunch',
      });
    }
    // 21: MAV_CMD_NAV_LAND
    else if (message.command === 21) {
      commands.push({
        id: index,
        type: 'navLand',
        data: {
          position: {
            lat: message.x / 1e7,
            lng: message.y / 1e7,
          },
        },
      });
    }
    // 22: MAV_CMD_NAV_TAKEOFF
    else if (message.command === 22) {
      commands[commands.length - 1].type = 'navTakeoff';
      commands[commands.length - 1].data.altitude = message.z;
    }
    // 30: MAV_CMD_NAV_CONTINUE_AND_CHANGE_ALT
    else if (message.command === 30) {
      commands.push({
        id: index,
        type: 'navContinueAndChangeAlt',
        data: {
          mode: message.param1,
          altitude: message.z,
        },
      });
    }
    // 31: MAV_CMD_NAV_LOITER_TO_ALT
    else if (message.command === 31) {
      commands.push({
        id: index,
        type: 'navLoiterToAlt',
        data: {
          position: {
            lat: message.x / 1e7,
            lng: message.y / 1e7,
          },
          altitude: message.z,
        },
      });
    }
    // 92: MAV_CMD_NAV_GUIDED_ENABLE
    else if (message.command === 92) {
      commands.push({
        id: index,
        type: 'navGuidedEnable',
        data: {
          enable: message.param1,
        },
      });
    }
    // 93: MAV_CMD_NAV_DELAY
    else if (message.command === 93) {
      commands.push({
        id: index,
        type: 'navDelay',
        data: {
          hold: message.param1,
          hour: message.param2,
          minute: message.param3,
          second: message.param4,
        },
      });
    }
    // 114: MAV_CMD_CONDITION_DISTANCE
    else if (message.command === 114) {
      commands.push({
        id: index,
        type: 'condDistance',
        data: {
          distance: message.param1,
        },
      });
    }
    // 115: MAV_CMD_CONDITION_YAW
    else if (message.command === 115) {
      commands.push({
        id: index,
        type: 'condYaw',
        data: {
          heading: message.param1,
          rate: message.param2,
          direction: message.param3,
          offset: message.param4,
        },
      });
    }
    // 177: MAV_CMD_DO_JUMP
    else if (message.command === 177) {
      commands.push({
        id: index,
        type: 'doJump',
        data: {
          item: message.param1,
          repeat: message.param2,
        },
      });
    }
    // 178: MAV_CMD_DO_CHANGE_SPEED
    else if (message.command === 178) {
      commands.push({
        id: index,
        type: 'doChangeSpeed',
        data: {
          type: message.param1,
          speed: message.param2,
          throttle: message.param3,
        },
      });
    }
    // 181: MAV_CMD_DO_SET_RELAY
    else if (message.command === 181) {
      commands.push({
        id: index,
        type: 'doSetRelay',
        data: {
          relay: message.param1,
          setting: message.param2,
        },
      });
    }
    // 182: MAV_CMD_DO_REPEAT_RELAY
    else if (message.command === 182) {
      commands.push({
        id: index,
        type: 'doRepeatRelay',
        data: {
          relay: message.param1,
          count: message.param2,
          time: message.param3,
        },
      });
    }
    // 183: MAV_CMD_DO_SET_SERVO
    else if (message.command === 183) {
      commands.push({
        id: index,
        type: 'doSetServo',
        data: {
          servo: message.param1,
          pwm: message.param2,
        },
      });
    }
    // 184: MAV_CMD_DO_REPEAT_SERVO
    else if (message.command === 184) {
      commands.push({
        id: index,
        type: 'doRepeatServo',
        data: {
          servo: message.param1,
          pwm: message.param2,
          count: message.param3,
          time: message.param4,
        },
      });
    }
    // 206: MAV_CMD_DO_SET_CAM_TRIGG_DIST
    else if (message.command === 206) {
      commands.push({
        id: index,
        type: 'doSetCamTriggDist',
        data: { distance: message.param1 },
      });
    }
    // 201: MAV_CMD_DO_SET_ROI
    else if (message.command === 201) {
      // MAV_ROI_NONE
      if (message.param1 === 0) {
        commands.push({
          id: index,
          type: 'doSetRoiNone',
        });
      }
      // MAV_ROI_LOCATION
      else if (message.param1 === 3) {
        commands.push({
          id: index,
          type: 'doSetRoiLocation',
          data: {
            position: {
              lat: message.x / 1e7,
              lng: message.y / 1e7,
            },
            altitude: message.z,
          },
        });
      }
    }
    // 208: MAV_CMD_DO_PARACHUTE
    else if (message.command === 208) {
      commands.push({
        id: index,
        type: 'doParachute',
        data: { action: message.param1 },
      });
    }
    // 211: MAV_CMD_DO_GRIPPER
    else if (message.command === 211) {
      commands.push({
        id: index,
        type: 'doGripper',
        data: {
          gripper: message.param1,
          action: message.param2,
        },
      });
    }
    // 212: MAV_CMD_DO_AUTOTUNE_ENABLE
    else if (message.command === 212) {
      commands.push({
        id: index,
        type: 'doAutotuneEnable',
        data: {
          enable: message.param1,
        },
      });
    }
    // 222: MAV_CMD_DO_GUIDED_LIMITS
    else if (message.command === 222) {
      commands.push({
        id: index,
        type: 'doGuidedLimits',
        data: {
          timeout: message.param1,
          minAlt: message.param2,
          maxAlt: message.param3,
          horizMoveLimit: message.param4,
        },
      });
    }
  });

  return commands;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default { toMavLink, fromMavLink };
